import React from "react";
import { Linkedin, Instagram, Twitter, Mail, Link2 } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const ICONS = {
  linkedin: Linkedin,
  newsletter: Mail,
  instagram: Instagram,
  twitter: Twitter,
  biolink: Link2,
};

const ORDER = [
  { id: "linkedin", label: "LinkedIn" },
  { id: "newsletter", label: "Newsletter" },
  { id: "instagram", label: "Instagram" },
  { id: "twitter", label: "Twitter" },
  { id: "biolink", label: "BioLink" },
];

export const SiteFooter = () => {
  const { settings } = useSettings();
  const email = settings.contact_email || "";
  const showEmail = !settings.hide_contact_email && !!email;

  const visibleSocials = ORDER.filter(
    ({ id }) => !settings[`hide_social_${id}`],
  );

  return (
    <footer
      data-testid="footer-section"
      className="absolute bottom-0 left-0 right-0 z-40 border-t border-black/10 bg-white/80 backdrop-blur-md"
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-3 gap-4">
        {showEmail ? (
          <a
            href={`mailto:${email}`}
            data-testid="contact-email-link"
            className="group flex items-center gap-2 hover:text-[#002FA7] transition-colors"
          >
            <span className="font-display text-[10px] font-bold tracking-[0.22em] uppercase">
              Email :{" "}
              <span className="normal-case font-medium tracking-[0.05em]">
                {email}
              </span>
            </span>
          </a>
        ) : (
          <span />
        )}

        <div className="flex items-center gap-1 sm:gap-2 md:mr-44">
          {visibleSocials.map(({ id, label }) => {
            const Icon = ICONS[id];
            const href = settings[`social_${id}`] || "#";
            return (
              <a
                key={id}
                href={href}
                data-testid={`social-${id}`}
                aria-label={label}
                target={href !== "#" ? "_blank" : undefined}
                rel="noreferrer"
                className="group flex items-center gap-2 px-3 py-2 hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                <Icon size={15} strokeWidth={1.6} />
                <span className="font-display text-[10px] font-bold uppercase tracking-[0.22em] hidden md:inline">
                  {label}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
